import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DsFormsModule } from '@bmw-ds/components';

import { useI18n } from '../../../i18n/services/i18n.service';

@Component({
  selector: 'cdf-customer-nsc-sync-checkbox',
  imports: [DsFormsModule, FormsModule],
  host: {
    class: 'row pt-6x',
  },
  template: `
    <ds-form-field class="col">
      <h3 class="mb-2x">{{ i18n('syncToNscDatabaseHeader') }}</h3>
      <ds-checkbox-group size="lg">
        <input ds-input type="checkbox" id="nsc-sync-checkbox" [(ngModel)]="checked" [disabled]="disabled()" />
        <label ds-label for="nsc-sync-checkbox">{{ i18n('syncToNscDatabaseCheckbox') }}</label>
      </ds-checkbox-group>
    </ds-form-field>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerNscSyncCheckboxComponent {
  protected readonly i18n = useI18n();

  readonly checked = model.required<boolean>();
  readonly disabled = input<boolean>(false);
}
